import type { Locale } from '@/i18n';

export interface ScreenshotAccount {
  email: string;
  locale: Locale;
  label: string;
}

export const SCREENSHOT_PASSWORD = 'inScreenshotWeTrust';

export const SCREENSHOT_ACCOUNTS: ScreenshotAccount[] = [
  { email: 'screenshot-en@withharmonia.com',    locale: 'en',    label: 'EN · English' },
  { email: 'screenshot-fr@withharmonia.com',    locale: 'fr',    label: 'FR · Français' },
  { email: 'screenshot-de@withharmonia.com',    locale: 'de',    label: 'DE · Deutsch' },
  { email: 'screenshot-es@withharmonia.com',    locale: 'es',    label: 'ES · Español' },
  { email: 'screenshot-it@withharmonia.com',    locale: 'it',    label: 'IT · Italiano' },
  { email: 'screenshot-nl@withharmonia.com',    locale: 'nl',    label: 'NL · Nederlands' },
  { email: 'screenshot-pl@withharmonia.com',    locale: 'pl',    label: 'PL · Polski' },
  { email: 'screenshot-pt@withharmonia.com',    locale: 'pt-BR', label: 'PT · Português' },
  { email: 'screenshot-uk@withharmonia.com',    locale: 'uk',    label: 'UK · Українська' },
];

const SCREENSHOT_EMAIL_RE = /^screenshot-[a-z-]+@withharmonia\.com$/i;

export function isScreenshotEmail(email: string | null | undefined): boolean {
  if (!email) return false;
  return SCREENSHOT_EMAIL_RE.test(email.trim().toLowerCase());
}
